import { useTranslation } from "@chr/online-shared-ui-localizations";
import { DrawerSuccessSummary } from "@/common/components/side-drawer/DrawerSuccessSummary";
import { Box, Stack } from "@mui/material";
import { Typography } from "@chr/eds-react";
import { ShowMoreText } from "@/common/components/show-more-text/ShowMoreText";

export interface ShareTrackingSuccessProps {
  emailToValues: string[];
  messageValue: string;
  onAgain: () => void;
}

export const ShareTrackingSuccess = ({
  emailToValues, 
  messageValue,
  onAgain,
}: ShareTrackingSuccessProps) => {
  const translate = useTranslation();

  return (
    <DrawerSuccessSummary 
      title={translate('Email on its way')}
      subTitle={translate('Your email request has been submitted and will be sent shortly. You can close this panel or use the button bellow to share with another email address.')}
      againButtonText={translate('Share again')}
      onAgain={onAgain}
    >
      <Stack spacing={2} overflow="clip">
        <Box>
          <Typography variant="subtitle200">{translate('Email To')}</Typography>
          { emailToValues.map( (email, index) => 
            <Typography variant="body200" key={index}>{email}</Typography>
          )}
        </Box>
        <Box>
          <Typography variant="subtitle200">{translate('Message')}</Typography>
          <ShowMoreText variant="body2" text={messageValue || '-'}/>
        </Box>
      </Stack>
    </DrawerSuccessSummary>
  );
}